module.exports = __webpack_public_path__ + "img/metal_h@2x.7afe9428.png";